import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { find } from 'lodash'

import { createCustomerOrderingPreferencesRequested } from '../../../actions/suites/orderingPreference'

import { getCurrentEventId } from '../../../selectors/events'
import { makeGetTabOrder } from '../../../selectors/order'
import { makeGetDisplaySuiteByOrder, getSuiteCustomers } from '../../../selectors/suites'

import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'

import TransferCustomer from '../../../components/tabs/OrderDetailsModal/TransferCustomer'

const mapStateToProps = (state, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''

  const getTabOrder = makeGetTabOrder()
  const getDisplaySuite = makeGetDisplaySuiteByOrder()
  const suiteInformation = getDisplaySuite(state, orderId)
  const tabOrder = getTabOrder(state, orderId)
  const order = TabOrderDetailsViewModel(tabOrder)
  const suiteCustomers = getSuiteCustomers(state, suiteInformation)
  const currentEventId = getCurrentEventId(state)
  const anonSuiteExists = !!find(suiteCustomers, (customer) => customer.displayName.includes("Anonymous"))

  const userNotes = order?.userNotes ?? ''

  return {
    ...order,
    anonSuiteExists,
    suiteInformation,
    currentEventId,
    suiteCustomers,
    userNotes,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const replace = ownProps?.history?.replace ?? function(){}
  const orderDetailsPath = `/tabs/${orderId}`

  return {
    onAddCustomerToSuite: (params) => dispatch(createCustomerOrderingPreferencesRequested(params)),
    onClose: () => replace(orderDetailsPath),
    onKeepTabOpen: (customerId) => {
      replace({
        pathname: `/tabs/${orderId}/close`,
        state: {
          customerId,
          splitOrderType: 'tab',
        },
      })
    },
    onPayNow: (customerId) => {
      replace({
        pathname: `/tabs/${orderId}/close`,
        state: {
          customerId,
        },
      })
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TransferCustomer))
